import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import CompanyCreatedListTable from "./CompanyCreatedListTable";

const CompanyCreatedList = () => {
    return (
        <Fragment>
            <CompanyCreatedListTable mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default CompanyCreatedList;